import { Pipe, PipeTransform } from '@angular/core';
import { memoize } from '../common/memoize-decorator';

@Pipe({
  name: 'routingRuleValue'
})
export class RoutingRuleValuePipe implements PipeTransform {

  @memoize()
  getRoutingRuleValue(item: any) {
    return item.id + ' - ' + item.name;
  }

  transform(value: any): string {
    return this.getRoutingRuleValue(value);
  }

}
